var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e6eff2;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "infos_icons",
    "data-name": "infos icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-3",
    "data-name": "Calque 2-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin-2",
    "data-name": "linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_171",
    "data-name": "Trac\\xE9 171",
    className: "cls-1",
    d: "M74.62,50.05V72.2H64.42c0-5.84.06-11.69,0-17.53a10.3,10.3,0,0,0-.89-4.16A5.33,5.33,0,0,0,58,47.68a6.55,6.55,0,0,0-5.76,6.79c-.07,5.91,0,11.82,0,17.73H42V39.64H52.15v4.2a12.36,12.36,0,0,1,7.52-4.94c6.23-1.49,12.66,1.76,14.44,7.92a11.84,11.84,0,0,1,.51,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_172",
    "data-name": "Trac\\xE9 172",
    className: "cls-1",
    d: "M25.66,39.57H35.87V72.2H25.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    className: "cls-1",
    cx: 30.77,
    cy: 29.42,
    r: 5.1
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 100,
    height: 100
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.6728a915f57066a66148793b7f3ffd52.svg";
export { ForwardRef as ReactComponent };